define('components/word-control/models/word-control',[], function() {

    "use strict";

    var WordControlModel = Backbone.Model.extend({

        "defaults": {
            "textToLoad": null,
            "selectableBlocks": [],
            "selectionType": 'word',
            "selectableSpanCounter": -1
        },

        "updateModel": function(options) {
            this.set({
                "textToLoad": options.textToLoad,
                "selectableBlocks": options.selectableBlocks,
                "selectionType": options.selectionType
            });
        }
    });
    return WordControlModel;
});

